export enum TypeOfStatisticEnum {
    reportValue = 'REPORT_VALUE',
    numberOfReports = 'NUMBER_OF_REPORTS'
}
